import axios from 'components/Axios';
import { resumes, resumesFindAll, resumesHighlight } from '../APIEndPoint';

const postResume = (payload) => {
    const promise = axios.post(resumes, payload);
    const dataPromise = promise.then((response) => response);
    return dataPromise;
};

const updateHighlightResume = (payload) => {
    const promise = axios.put(`${resumesHighlight}/${payload?.resumeId}`, { status: payload?.status });
    const dataPromise = promise.then((response) => response);
    return dataPromise;
};

const getAllResume = () => {
    const promise = axios.get(resumesFindAll);
    const dataPromise = promise.then((response) => response.data);
    return dataPromise;
};

const getResume = (resumeId) => {
    const promise = axios.get(`${resumes}/${resumeId}`);
    const dataPromise = promise.then((response) => response);
    return dataPromise;
};

const deleteResume = (resumeId) => {
    const promise = axios.delete(`${resumes}/${resumeId}`);
    const dataPromise = promise.then((response) => response);
    return dataPromise;
};

const getResumeByUsername = (username) => {
    const promise = axios.get(`${resumes}/byUserName/${username}`);
    const dataPromise = promise.then((response) => response);
    return dataPromise;
};

export {
    postResume,
    updateHighlightResume,
    getAllResume,
    getResume,
    deleteResume,
    getResumeByUsername
};
